import PrebuiltBetImpl from './prebuilt-bet.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const UIView = MojitoCore.Presentation.UIView;

/**
 * PrebuiltBet view that renders prebuilt bet card.
 *
 * @class PrebuiltBet
 * @memberof Mojito.Modules
 */

/**
 * Prebuilt bet prop types.
 *
 * @property {node} [children] - Child components.
 * @property {object} event - Event data.
 * @property {object} market - Market data.
 * @property {object} [boostedMarket] - Boosted market data.
 * @property {Function} [onEventClick] - Callback to get state of child element loading.
 * @property {boolean} [showMarketName = true] - If true, then market name per part will be shown.
 * @property {string} [class] - Class name.
 *
 * @memberof Mojito.Modules.PrebuiltBet
 */
const propTypes = {
    children: PropTypes.node,
    event: PropTypes.object.isRequired,
    market: PropTypes.object.isRequired,
    boostedMarket: PropTypes.object,
    onEventClick: PropTypes.func,
    showMarketName: PropTypes.bool,
    class: PropTypes.string,
};

const defaultProps = {
    showMarketName: true,
    class: '',
};

export default UIView('PrebuiltBet', PrebuiltBetImpl, propTypes, defaultProps);
